export default __webpack_public_path__ + "static/screenapp-for-coperate-use-9a90ad4edb9144209d9639b4d1a719dc.png";